export default function () {
  return <div className="inline-block dots-loader" />
}
